import React from 'react';
import CmPagination from '../../../GeneralComponents/ui/CmPagination';

export default function RecordsPagination({ page, total, perPage, onPageChange, onPerPageChange }) {
  return (
    <CmPagination
      page={page}
      total={total}
      perPage={perPage}
      onChange={onPageChange}
      onPerPageChange={onPerPageChange}
    />
  );
}
